import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/sites/successfullAddSiteDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddSite_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddSite_action_icon' />
        <Typography className='SuccessfulAddSite_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddSiteDialog = ({ openSuccessfulAddSite, setOpenSuccessfulAddSite, setOpenAddSite, siteId }) => {

    const navigate = useNavigate();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddSite(false);
        setOpenAddSite(true);
    }, [setOpenAddSite, setOpenSuccessfulAddSite]);

    const handleNavigateToSitePage = useCallback(() => {
        navigate(`site_details/${siteId}`);
    }, [siteId, navigate]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddSite(false);
    }, [setOpenSuccessfulAddSite]);

    return (
        <Dialog open={openSuccessfulAddSite} onClose={handleClose} classes={{ paper: 'SuccessfulAddSite_dialog' }} fullWidth>
            <IconButton onClick={handleClose} className='SuccessfulAddSite_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddSite_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddSite_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddSite_check_icon' />
                <Typography className='SuccessfulAddSite_message'>Ajouté avec succès !</Typography>
                <Box className='SuccessfulAddSite_action_container'>
                    <ActionBox
                        icon={"pepicons-pop:file"}
                        text="Page de site"
                        onClick={handleNavigateToSitePage}
                    />
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text="Liste des sites"
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text="Ajouter un site"
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};